var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackbonejsPlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002A41",
    d: "M64 31.124L15 3.239v121.522l49-27.885 49 27.885V3.239L64 31.124zM40.714 63.999l24.369-13.89 24.368 13.89-24.368 13.892-24.369-13.892zM32 29.934l17.433 9.937L32 49.809V29.934zm0 48.257l16.126 9.191L32 96.575V78.191zm65 18.384l-16.127-9.192L97 78.191v18.384zM79.566 39.87L97 29.934v19.875L79.566 39.87z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbonejsPlain);
export default __webpack_public_path__ + "static/media/BackbonejsPlain.a5f0c44f58f82d3f9a9cd68fceeddc46.svg";
export { ForwardRef as ReactComponent };